import {createSlice} from '@reduxjs/toolkit';
const initialState = {
  options: [],
  current_option: null,
};

const revisionsSlice = createSlice({
  name: 'revisions',
  initialState,
  reducers: {
    setRevisionOptions(state, action) {
      state.options = action.payload?.data;

      if (action.payload.current_revision) {
        state.current_option = action.payload?.data?.filter(
          option => option?.code === action.payload.current_revision,
        )[0];
      } else {
        state.current_option = action.payload.data[0];
      }
    },
    setCurrentRevisionOption(state, action) {
      state.current_option = action.payload;
    },
  },
});

export const {setRevisionOptions, setCurrentRevisionOption} =
  revisionsSlice.actions;

export default revisionsSlice.reducer;
